import type { FC } from 'react'
import type { LoadingProps } from '.'
import s from './loading.module.css'

const Loading: FC<LoadingProps> = ({ title = 'Aguarde...', description = null }) => {
  return (
    <div className={s.root}>
      <div className={s.loader} />
      {title && <h2 className={s.title}>{title}</h2>}
      {description && <p className={s.description}>{description}</p>}
    </div>
  )
}

export default Loading
